import store from "../store/index.js";
import { canManageResource } from "../middleware/permission.js";

/**
 * Resource Management Permission Directive
 * 
 * Usage in components:
 * <button v-manage="'book'">Add Book</button>
 * 
 * This will show/hide the element based on whether the user can manage the specified resource
 */
const manage = {
  mounted(el, binding) {
    const resourceType = binding.value;
    const role = store.getters._getCurrentRole || 3;
    
    // If no resource type specified, remove by default
    if (!resourceType) {
      el.parentNode.removeChild(el);
      return;
    }
    
    // Check if user can manage the resource type
    if (!canManageResource(resourceType)) {
      el.parentNode.removeChild(el);
    }
  },
};

export default manage; 